import * as E from 'fp-ts/Either';
import { pipe, tuple } from 'fp-ts/function';
import * as RA from 'fp-ts/ReadonlyArray';
import * as S from 'fp-ts/Semigroup';
import * as s from 'fp-ts/string';
import * as t from 'io-ts';
import * as RR from '../fp-ts/ReadonlyRecord';
/**
 * Create an isomorphic codec. Usefull if encoded value is represented by magic
 * strings/numbers.
 *
 * @example
 * const type = iso({
 *  '0': 'a'
 * })
 *
 * type.decode('0')
 * // => E.right('a')
 *
 * type.encode('a')
 * // => '0'
 */
export var iso = function (map, name) {
    if (name === void 0) { name = 'Iso'; }
    var reverseMap = pipe(map, RR.collect(s.Ord)(function (key, value) { return tuple(value, key); }), RR.fromFoldable(S.first(), RA.Foldable));
    return new t.Type(name, function (u) { return t.string.is(u) && pipe(map, RR.elem(s.Eq)(u)); }, function (u, c) { return pipe(t.string.validate(u, c), E.chainOptionK(function () { return [{ value: u, context: c }]; })(RR.lookupV(map))); }, function (a) { return reverseMap[a]; });
};
